import { useQuery } from '@tanstack/react-query';
import { useAuth } from '@/hooks/use-auth-compat';
import { getAnalyticsSummary, getAnalyticsInsights, type AnalyticsSummaryResponse, type AnalyticsInsightsResponse } from '@/services/analyticsService';

export function useAnalyticsSummary() {
  const auth = useAuth();
  const token = auth.user?.access_token ?? '';

  return useQuery<AnalyticsSummaryResponse>({
    queryKey: ['analytics', 'summary'],
    queryFn: () => getAnalyticsSummary(token),
    enabled: !!token,
    staleTime: 60_000,
  });
}

export function useAnalyticsInsights() {
  const auth = useAuth();
  const token = auth.user?.access_token ?? '';

  return useQuery<AnalyticsInsightsResponse>({
    queryKey: ['analytics', 'insights'],
    queryFn: () => getAnalyticsInsights(token),
    enabled: !!token,
    staleTime: 60_000,
  });
}
